import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';

import ModalBox from '../../components/ModalBox';

import { counties } from './TaiwanDistrict';
import { CustomInput, CustomRadio, CustomDropdown } from '../../components/CustomForm';
import { nl2br } from '../../utils/wordingSystem';

import './index.scss';
import SNSPanel from '../../components/SNSPanel';

const ContactPage = ({ wording, common }) => {
  const [formData, setFormData] = useState({});
  const [towns, setTowns] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [sendCompleted, setSendCompleted] = useState(false);
  const [errorMsgBag, setErrorMsgBag] = useState(null);
  const [spaceTypes, setSpaceTypes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    async function fetchSpaceTypes() {
      const { data: _spaceTypes } = await Axios.get('/api/contact/space-types');
      setSpaceTypes(_spaceTypes);
    }
    fetchSpaceTypes();
  }, [])

  const handleSetCounty = (value) => {
    const currentCounty = counties.find(item => item.county === value);
    setTowns(currentCounty.towns);
    handleInputChanged(value, 'county');
  }

  const handleSetTown = (value) => {
    handleInputChanged(value, 'town');
  }

  const handleSetSpaceType = value => {
    handleInputChanged(value, 'space_type');
  }

  const handleInputChanged = (value, name) => {

    setFormData(prev => {
      const newFormData = { ...prev };
      newFormData[name] = value;
      return newFormData;
    })
  }

  const handleSubmitClick = async e => {
    if (uploading) return;

    setUploading(true);
    setErrorMsgBag(null);

    const submitFormData = {
      ...formData,
      location: `${formData.county || ''}${formData.town || ''}`
    }

    try {
      await Axios.post('/api/contact/submit', submitFormData);
      window.gtag?.('event', 'conversion', {'send_to': 'AW-16632928208/YharCKz6is4ZENCvmfs9'});
      setUploading(false);
      setSendCompleted(true);
      setModalOpen(true);
    }
    catch (error) {
      setUploading(false);
      setErrorMsgBag(error.response.data.errors);
      console.log(error.response.data.errors)
    }

  }

  const _w = wording, _c = common;
  return (
    <React.Fragment>
      <Helmet>
        <title>{_w.meta_title}</title>
      </Helmet>
      <ModalBox className="contact-modal" open={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="modal">
          <div className="title type-heading -en -h6">{_w.thanks}</div>
          <div className="description type-text -ch -md">{_w.receive}</div>
          <div className="image">
            <img src="/images/contact-popup.svg" alt="" />
          </div>
        </div>
      </ModalBox>
      <div className="contact-page">
        <SNSPanel />
        <div className="contact-topic">
          <div className="container">
            <div className="topic inner-container">
              <div className="title">
                <h1 className="type-heading -en -h2">
                  <span>{_w.heading}&nbsp;</span>
                  <span className="highlight">{_w.heading_color}</span>
                </h1>
              </div>
              <div className="illustration">
                <img src="/images/contact-heading.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="inner-container">
            <div className="contact-section">
              <div className="contact-form row">
                <div className="item col-md-6">
                  <CustomInput
                    name="name"
                    errorMsgBag={errorMsgBag}
                    label={_w.name}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.name}
                    empty={true} />
                </div>
                <div className="item gender-selector col-md-6">
                  <CustomRadio
                    name="gender"
                    options={['先生', '小姐']}
                    getInput={handleInputChanged}
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="email"
                    errorMsgBag={errorMsgBag}
                    label={_w.email}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.email}
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="phone"
                    errorMsgBag={errorMsgBag}
                    label={_w.phone}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.phone}
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="company"
                    errorMsgBag={errorMsgBag}
                    label={_w.company}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.company}
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomDropdown
                    name="space_type"
                    label={_w.category}
                    errorMsgBag={errorMsgBag}
                    category={_w.prefix_with + _w.category}
                    data={spaceTypes}
                    getInput={handleSetSpaceType} />
                </div>
                <div className="item col-md-6 district-selector">
                  <CustomDropdown
                    className="county"
                    name="location"
                    label={_w.location}
                    errorMsgBag={errorMsgBag}
                    category={_w.location_county}
                    data={counties.map(item => item.county)}
                    getInput={value => handleSetCounty(value)} />
                  <CustomDropdown
                    className="town"
                    name="location"
                    label=""
                    errorMsgBag={errorMsgBag}
                    category={_w.location_town}
                    data={towns ? towns.map(item => item.town) : null}
                    getInput={value => handleSetTown(value)} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="feet"
                    errorMsgBag={errorMsgBag}
                    label={_w.space}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.space}
                    type="number"
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="budget"
                    errorMsgBag={errorMsgBag}
                    label={_w.budget}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix_with + _w.budget}
                    type="number"
                    empty={true} />
                </div>
                <div className="item col-md-6">
                  <CustomInput
                    name="deadline"
                    errorMsgBag={errorMsgBag}
                    label={_w.deadline}
                    getInput={handleInputChanged}
                    placeholder="YYYY-MM-DD"
                    type="date"
                    empty={true} />
                </div>
                <div className="item col-md-12">
                  <CustomInput
                    name="message"
                    errorMsgBag={errorMsgBag}
                    label={_w.message}
                    getInput={handleInputChanged}
                    placeholder={_w.prefix + _w.message}
                    empty={true} />
                </div>
                <div className="item col-md-12">
                  <button className={`submit -dark text-button ${sendCompleted ? '-active' : ''}`} disabled={uploading || sendCompleted} onClick={handleSubmitClick}>
                    <span className="type-text -en -sm">{uploading ? _w.sending : (sendCompleted ? _w.send_completed : _w.send)}</span>
                  </button>
                </div>
              </div>
              <div className="company-info">
                <div className="list">
                  <div className="item type-text -en -md">{nl2br(_w.address)}</div>
                  <div className="item type-text -en -md">{nl2br(_w.phone_number)}</div>
                  <div className="item type-text -en -md">{_w.time}</div>
                </div>
                <div className="follow">
                  <div className="title type-text -ch -md">{_w.follow_us}</div>
                  <div className="item">
                    <a className="type-heading -en -h4" href={_c.facebook}>Facebook</a>
                  </div>
                  <div className="item instagram">
                    <a className="type-heading -en -h4" href={_c.instagram}>Instagram</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ContactPage;
